import { useEffect, useMemo, useState } from 'react';
import { withNamespaces } from 'react-i18next';

import TableFilter from 'src/components/TableFilter';

import { BidStatuses } from '../constants';

const FilteringComponent = ({
    t,
    onChange,
}) => {
    const [tableFilters, setTableFilters] = useState({
        status: null,
        search: null,
    });

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Status',
                icon: <i className="ri-toggle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: Object.values(BidStatuses).map((status) => ({
                    id: status.title,
                    title: status.title,
                })),
                formatter: (item) => t(item.title),
            },
            {
                type: 'search_textbox',
                name: 'search',
                title: 'Search carriers',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.search,
                options: {
                    placeholder: 'Search carriers',
                    typingDelay: 750,
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({
                        ...currentState,
                        search: value,
                    }));
                },
            },
        ];
    }, [
        tableFilters,
        t,
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {};

            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined;
            }

            setTableFilters((currentState) => ({
                ...currentState,
                ...result,
            }));
        } else {
            setTableFilters({
                status: null,
                search: independentTabsData?.search,
            });
        }
    };

    useEffect(() => {
        onChange && onChange(tableFilters);
    }, [
        onChange,
        tableFilters,
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab="status"
            tabs={tableFilterTabs}
            onOkButtonClicked={onTableFilterOkButtonClicked}
        />
    );
};

export default withNamespaces()(
    FilteringComponent
);
